import styled from '@emotion/styled';
import { CUSTOM_BREAK_POINT } from '../Block.styled';

type Props = {
  id: string;
  className: string;
  image: string;
  size: number;
  top: number;
  left: number;
  rotate: number;
  isDisplay?: boolean;
};

const ImageCard = ({
  id,
  className,
  image,
  size,
  top,
  left,
  rotate,
  isDisplay = true,
}: Props) => {
  return (
    <ImagePositionWrapper top={top} left={left} isDisplay={isDisplay}>
      <Image
        id={id}
        className={className}
        size={size}
        image={image}
        rotate={rotate}
      />
    </ImagePositionWrapper>
  );
};
const ImagePositionWrapper = styled.div<{
  top: number;
  left: number;
  isDisplay: boolean;
}>`
  display: ${(props) => (props.isDisplay ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;

  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;

  width: 100%;
  height: 100%;
  transition: all 1s;
`;

const Image = styled.div<{
  size: number;
  image: string;
  rotate: number;
}>`
  width: ${(props) => props.size * 7}px;
  height: ${(props) => props.size * 10}px;
  transform: rotate(${(props) => props.rotate}deg);
  background-image: url(${(props) => props.image});
  background-size: 100% auto;
  background-repeat: no-repeat;

  transition: all 0.5s;
`;

export default ImageCard;
